import { ChangeDetectionStrategy, Component } from '@angular/core';

import { MancalaMove } from '@everyboard/games/kalah';
import { KalahMoveGenerator } from '@everyboard/games/kalah';
import { KalahRules } from '@everyboard/games/kalah';

import { MancalaComponent } from '../common/MancalaComponent';
import { NumberedCircleComponent } from '../common/numbered-circle.component';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-kalah-component',
    templateUrl: './../common/mancala.component.html',
    styleUrls: ['../../../components/game-components/game-component/game-component.scss'],
    imports: [NumberedCircleComponent],
})
export class KalahComponent extends MancalaComponent<KalahRules> {

    public constructor() {
        super('Kalah');
        this.aiConfig = this.createAIConfig(new KalahMoveGenerator());
        this.encoder = MancalaMove.encoder;
    }

}
